import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog'

const OFFSET_PRESETS = [0, 0.3, 0.5, 0.8, 1.0]

type SettingsDialogProps = {
  open: boolean
  onOpenChange: (open: boolean) => void
  displayOffset: number
  onDisplayOffsetChange: (offset: number) => void
}

export const SettingsDialog = ({ open, onOpenChange, displayOffset, onDisplayOffsetChange }: SettingsDialogProps) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>設定</DialogTitle>
        </DialogHeader>
        <div className="space-y-4">
          <div>
            <p className="text-sm font-medium mb-3">先読みオフセット（秒）</p>
            <div className="flex flex-wrap gap-2">
              {OFFSET_PRESETS.map((s) => (
                <button
                  key={s}
                  onClick={() => onDisplayOffsetChange(s)}
                  className={`px-4 py-2 rounded-md text-sm font-medium transition-colors ${
                    displayOffset === s
                      ? 'bg-primary text-primary-foreground'
                      : 'bg-muted text-muted-foreground hover:bg-muted/80'
                  }`}
                >
                  {s.toFixed(1)}s
                </button>
              ))}
            </div>
            <p className="text-xs text-muted-foreground mt-2">現在の設定: {displayOffset.toFixed(1)}秒</p>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  )
}
